import { createFileRoute, useNavigate, useParams, useSearch } from "@tanstack/react-router";
import { FilterPage } from "../components/filters/FilterPage";
import { filterSearchSchema } from "../components/filters/filter-search";
import { Skeleton } from "../components/ui/skeleton";
import { isNotFound, NotFound, Unavailable } from "../components/ui/states";
import { useFilter } from "../lib/filters";
import { strings } from "../lib/strings";

/** A saved filter (BUILD_SPEC §12.9): its query and view, edited in the address until it is saved. */
function Page() {
  const { filterId } = useParams({ from: "/admin/filters/$filterId" });
  const search = useSearch({ from: "/admin/filters/$filterId" });
  const navigate = useNavigate({ from: "/admin/filters/$filterId" });
  const filter = useFilter(filterId);
  if (filter.isLoading)
    return (
      <div className="mx-auto max-w-6xl space-y-3 px-6 py-8">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-24 w-full" />
      </div>
    );
  if (filter.data === undefined)
    return (
      <div className="mx-auto max-w-3xl px-6 py-12">
        {isNotFound(filter.error) ? (
          <NotFound what={strings.filters.thisFilter} page />
        ) : (
          <Unavailable what={strings.filters.thisFilter} onRetry={() => void filter.refetch()} page />
        )}
      </div>
    );
  return (
    <FilterPage
      key={filter.data.id}
      filter={filter.data}
      search={search}
      onSearch={(next) => void navigate({ search: (prev) => ({ ...prev, ...next }), replace: next.jql !== undefined })}
    />
  );
}

export const Route = createFileRoute("/admin/filters/$filterId")({
  validateSearch: filterSearchSchema,
  component: Page,
});
